import { Controller } from "@hotwired/stimulus"
import lazySizes from "lazysizes"

export default class extends Controller {
  static values = {
    margin: { type: String, default: "200px" },
  }

  connect() {
    this.observer = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => entry.isIntersecting)) return

      this.observer.disconnect()
      this.element.querySelectorAll("img.lazyload").forEach((img) => lazySizes.loader.unveil(img))
    }, { rootMargin: this.marginValue })
    this.observer.observe(this.element)
  }

  disconnect() {
    this.observer?.disconnect()
  }
}
